import { themeType } from '../../ui-kit/helpers';
import { isMobileOnly } from 'react-device-detect';

export const dashboardBgColor = themeType === 'light' ? 'var(--bs-gray-200)' : 'var(--bs-dark)';

export const widgetBorderColor = themeType === 'light' ? 'border-light' : 'border-dark';

export const widgetBgColor = themeType === 'light' ? 'white' : 'var(--bs-card-cap-bg)';

export const widgetInnerPadding = isMobileOnly ? 'p-0' : 'p-2';
